function BookImage({ src }) {
    return (
        <div class="bookdetails1">
            <img src={src} alt="Book" />
        </div>
    );
}

export default BookImage;
